import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import times from "lodash/times";
import React from "react";
import styled from "styled-components";

export const ProgressDots: React.FC<{
  progress: number;
  total: number;
}> = ({ progress, total }) => (
  <Row>
    {times(total, (num) => (
      <Dot
        key={num}
        $color={num === progress ? Core.surface.enabled : undefined}
      />
    ))}
  </Row>
);

const Dot = styled.div<{ $color?: string }>`
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color || Core.surface.subdued};
  margin: 2.5px;
`;
